import axios from 'axios';
import { OCTOPUS_BASE_URL } from '.';

const path = '/link-to-deliver';
const url = `${OCTOPUS_BASE_URL}${path}`;

export const getPreBookingEvents = (preBookingId: string) => axios.get(`${url}/pre-booking/${preBookingId}/events`);
